module.exports = __webpack_public_path__ + "assets/units/abilities/Mr. Stitches 1.svg";